export default __webpack_public_path__ + "static/media/panas-high-five.f4663173.png";